import { LoggedInSocialBar } from './LoggedInSocialBar';

export default LoggedInSocialBar;
